import { createApi } from '@reduxjs/toolkit/query/react';
import { idType, selectItemType } from '@src/types';
import { baseQuerySample } from '@store/helpers';
import { getOrderedLosOptions } from '@utils/los';

type GetModeOfTransportAllTypesArgs = {
  isContractorVersion?: boolean;
  isActive?: boolean;
};

type RideEquipmentSearchArgs = {
  q: string;
};

type RideEquipmentIcd10Item = {
  code: string;
  description: string;
  label: string;
};

export type RideEquipmentCatalogItem = {
  id: number;
  name: string;
};

export const selectsApi = createApi({
  reducerPath: 'Select',
  tagTypes: ['Select'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getSpokenLanguages: builder.query<Array<selectItemType>, {}>({
      query: () => '/v1/member/info/spoken_languages',
    }),

    getTableUsersId: builder.query<any, any>({
      query: ({ memberId }) => ({
        url: `/v1/logs/audit/user-select-response/${memberId}`,
      }),
    }),

    getAgreementsStatus: builder.query<Array<selectItemType>, { path: string }>(
      {
        query: ({ path }) => ({
          url: `/v1/${path}/status`,
        }),
      }
    ),
    getModeOfTransportSelectData: builder.query<
      Array<selectItemType>,
      { path: string }
    >({
      query: ({ path }) => ({
        url: path,
      }),
    }),
    // getModeOfTransportAllTypes: builder.query<Array<selectItemType>, {}>({
    //   query: () => ({
    //     url: `/v1/contractors/mode_of_transport/category-type/3`,
    //   }),
    // }),
    // getModeOfTransportAllTypes: builder.query<
    //   Array<selectItemType>,
    //   GetModeOfTransportAllTypesArgs | void
    // >({
    //   query: () => ({
    //     url: `/v2/contractors/los/category-type/all`,
    //   }),
    // }),

    getModeOfTransportAllTypes: builder.query<
      Array<selectItemType>,
      GetModeOfTransportAllTypesArgs | void
    >({
      async queryFn(arg, { getState }, _extraOptions, baseQuery) {
        const state = getState() as any;
        const isContractor =
          arg?.isContractorVersion ?? state.users.isContractorVersion;

        //TODO per Areg`s request
        // const targetUrl = isContractor
        //   ? `/v2/contractors/los/category-type/all`
        //   : `/v1/company/mode_of_transport/all`;

        const targetUrl = `/v1/company/mode_of_transport/all`;
        const result = await baseQuery({
          url: targetUrl,
          params: {
            isActive: arg?.isActive ?? false,
          },
        });
        return result.data
          ? {
              data: getOrderedLosOptions(
                result.data as any
              ) as Array<selectItemType>,
            }
          : { error: result.error as any };
      },
    }),
    getBusinessTypes: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: '/v1/company/lob',
      }),
    }),
    getBusinessTypesById: builder.query({
      query: ({ id }: { id: number }) => ({
        url: `/v1/company/lob/${id}`,
      }),
    }),
    getCategoryTypes: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: '/v1/company/service/category',
      }),
    }),
    getRideServiceCategoryTypes: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: '/v1/company/service/payor/service/type',
      }),
    }),
    getServicesTypes: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: '/v1/company/service/type',
      }),
    }),
    getEquipmentAndAddon: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: '/v1/company/equipment-and-addons',
      }),
    }),
    //TODO its not working i waiting Nare for end this tusk
    getRideEquipmentIcd10: builder.query<
      Array<RideEquipmentIcd10Item>,
      RideEquipmentSearchArgs
    >({
      query: ({ q }) => ({
        url: '/v2/rides/equipment/icd10',
        params: { q },
      }),
    }),
    getRideEquipmentCatalog: builder.query<
      Array<RideEquipmentCatalogItem>,
      RideEquipmentSearchArgs
    >({
      query: ({ q }) => ({
        url: '/v2/rides/equipment/catalog',
        params: { q },
      }),
    }),
    getMarkUpType: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: '/v1/company/rate/mark-types',
      }),
    }),
    getBillQualifierType: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: '/v1/company/rate/bill-qualifier-types',
      }),
    }),
    getGenderSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: '/v1/member/info/genders',
      }),
    }),
    getMethodVerifications: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/member/info/method-verification`,
      }),
    }),
    getVehicleModelSelectDataByMakeId: builder.query<
      Array<selectItemType>,
      { id: idType }
    >({
      query: ({ id }) => ({
        url: `/v1/vehicles/vehicles/model/${id}`,
      }),
    }),
    getVehicleModelSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/vehicles/vehicles/model/select`,
      }),
    }),
    getVehicleMakeSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/vehicles/vehicles/make/select`,
      }),
    }),
    getVehicleById: builder.query({
      query: ({ id }: { id: number }) => ({
        url: `/v1/vehicles/vehicle/${id}`,
      }),
    }),
    getVehicleLosById: builder.query({
      query: ({ id }: { id: number }) => ({
        url: `/v1/vehicles/vehicle/mode-of-transport/${id}`,
      }),
    }),
    getVehicleColorSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/vehicles/vehicles/color/select`,
      }),
    }),
    getVehicleTypeSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/vehicles/vehicles/type/select`,
      }),
    }),
    getVehicleStatusSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/vehicles/vehicles/status/select`,
      }),
    }),
    getVehicleRegistrationIssuingAuthoritySelectData: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/vehicles/registration/issuing-authority/all`,
      }),
    }),
    getVehicleInspectionTypeSelectData: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/vehicles/inspection/issuing-authority/all`,
      }),
    }),
    getVehicleInspectionOrganizationSelectData: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/vehicles/inspection/inspection-organization/all`,
      }),
    }),
    getVehicleInspectionDeterminationSelectData: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/vehicles/inspection/inspection-status/all`,
      }),
    }),
    getVehiclePermitIssuingAuthoritySelectData: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/vehicles/permit/type/all`,
      }),
    }),
    getPersonnelIdentificationTypeSelectData: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/personnel/identification/types/select`,
      }),
    }),
    getPersonnelIdentificationIssuingSelectData: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/personnel/identification/issuing/select`,
      }),
    }),
    getPersonnelCertificationsTypeSelectData: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/personnel/certifications/types/select`,
      }),
    }),
    getPersonnelCertificationsIssuingSelectData: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/personnel/certifications/issuing/select`,
      }),
    }),
    getPersonnelScreeningsTypeSelectData: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/personnel/screenings/types/select`,
      }),
    }),
    getPersonnelScreeningsIssuingSelectData: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/personnel/screenings/issuing/select`,
      }),
    }),
    getPersonnelPermitTypeSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/personnel/permits/types/select`,
      }),
    }),
    getPersonnelPermitIssuingSelectData: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/personnel/permits/issuing/select`,
      }),
    }),
    getContractorsTypeSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v2/contractors/contractors-type/select`,
      }),
    }),
    getContractorsAtmsSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/contractors/info/dispatch-platform`,
      }),
    }),
    getContractorsStatusSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/contractors/info/contractor-status`,
      }),
    }),
    getRelationshipSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/places/info/types`,
      }),
    }),
    getInsuranceTypeSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/contractors/insurance/type/select`,
      }),
    }),
    getInsuranceInsurerSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/contractors/insurance/insuler/select`,
      }),
    }),
    getInsuranceBrokerSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/contractors/insurance/broker/select`,
      }),
    }),
    getContractTypeSelectData: builder.query<
      Array<selectItemType>,
      { path: string }
    >({
      query: ({ path }) => ({
        url: `/v1/${path}/contracts/types`,
      }),
    }),
    getLicenseTypeSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/contractors/permit/licence-types/select`,
      }),
    }),
    getPermitInsuranceTypeSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/contractors/permit/insurance-types/select`,
      }),
    }),
    getUserTypeSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/users/info/type/all`,
      }),
    }),
    getSurveyTemplateSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/users/survey-templates/getAll`,
      }),
    }),
    getPersonnelItemTypeSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/personnel/info/type/select`,
      }),
    }),
    getPersonnelItemStatusSelectData: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/personnel/info/status/select`,
      }),
    }),
    getPreferenceAllTags: builder.query({
      query: () => ({
        url: `/v1/users/tags`,
      }),
    }),
    getPreferenceSelectedTags: builder.query({
      query: () => ({
        url: `/v1/users/tags/member`,
      }),
    }),
    getPlacesLocationTypes: builder.query({
      query: () => ({
        url: `/v1/places/location/types`,
      }),
    }),
    getLimitsTypes: builder.query({
      query: () => ({
        url: `/v1/member/limits/types`,
      }),
    }),
    getMemberInfoPriority: builder.query({
      query: () => ({
        url: `/v1/member/info/priority`,
      }),
    }),
    getVerificationMethods: builder.query({
      query: () => ({
        url: `/v1/member/info/method-verification`,
      }),
    }),
    getSendingMethods: builder.query({
      query: () => ({
        url: `/v1/member/info/sending-method`,
      }),
    }),
    getWarningMethods: builder.query({
      query: () => ({
        url: `/v1/member/info/warning-method`,
      }),
    }),
    // getServices: builder.mutation({
    //   query: ({ body = {} }) => ({
    //     url: `/v1/contractors/info/contractors`,
    //     method: 'POST',
    //     body,
    //   }),
    // }),
    getServices: builder.mutation({
      query: ({ body = {} }) => ({
        url: `/v1/company/service/select-response`,
        method: 'PUT',
        body,
      }),
    }),
    getContractors: builder.query({
      query: () => ({
        url: `/v1/contractors/info/contractors`,
      }),
    }),
    getLosContractors: builder.mutation({
      query: (body) => ({
        url: `/v1/contractors/info/contractors`,
        method: 'POST',
        body,
      }),
    }),
    getTimes: builder.query({
      query: () => ({
        url: `/v1/places/info/times`,
      }),
    }),
    getPlaceLocationsSelect: builder.query({
      query: () => ({
        url: `/v1/places/places-locations/select-location`,
      }),
    }),
    getPayorSelect: builder.query({
      query: () => ({
        url: `/v1/company/info/payers-select`,
      }),
    }),
    getHealthPlanSelect: builder.query({
      query: () => ({
        url: `/v1/member/info/health-plan`,
      }),
    }),
    getUserTypeFiltrationSelect: builder.query({
      query: () => ({
        url: `/v1/users/info/select/user/type/roles`,
      }),
    }),
    getUserPermissionsFiltrationSelect: builder.query<
      Array<selectItemType>,
      {}
    >({
      query: () => ({
        url: `/v1/users/info/type/all`,
        params: {
          page: 0,
          size: 100,
        },
      }),
      transformResponse: (response: { content?: Array<selectItemType> }) =>
        (response?.content || []).map((option) => ({
          ...option,
          label: option.value,
        })),
    }),
    getChangedByFiltrationSelect: builder.query({
      query: ({ model, associatedId }) => ({
        url: `/v1/logs/audit/user-modified-response/${model}/${associatedId}`,
      }),
    }),
    getViewedByFiltrationSelect: builder.query({
      query: ({ model, associatedId }) => ({
        url: `/v1/logs/audit/user-view-response/${model}/${associatedId}`,
      }),
    }),
    getNotedByFiltrationSelect: builder.query({
      query: ({ type, associatedId }) => ({
        url: `/v1/notes/${type}/users/select?associatedId=${associatedId}`,
      }),
    }),
    getRideSegmentStatusSelect: builder.query({
      query: () => ({
        url: `/v1/rides/ride-segments/status`,
      }),
    }),

    getRideSegmentReactivateStatus: builder.query({
      query: ({ segmentId }) => `/v1/rides/ride-segments/status/${segmentId}`,
    }),

    rideSegmentReactivate: builder.mutation({
      query: ({ segmentId, ...body }) => ({
        url: `/v1/rides/ride-segments/reactivate/${segmentId}`,
        method: 'POST',
        body,
      }),
    }),

    getRideSegmentStatusChangeSelect: builder.query({
      query: () => ({
        url: `/v1/rides/ride-segments/status-segment`,
      }),
    }),
    getReasonsByStatusSelect: builder.query({
      query: ({ id }) => ({
        url: `/v1/rides/info/reasons/${id}`,
      }),
    }),
    getActiveContractors: builder.query({
      // query: ({ payorId }: { payorId: number }) => {
      query: () => {
        return {
          // url: `/v1/contractors/info/active-contractors/${payorId}`,
          url: `/v1/contractors/info/active-contractors`,
        };
      },
    }),
    getPayerActiveContractors: builder.query<
      Array<selectItemType>,
      { dateOfService: string; losId: number }
    >({
      query: ({ dateOfService, losId }) => ({
        url: `/v2/search/contractor/active-contractors`,
        params: { dateOfService, losId },
      }),
    }),
    getActiveContractorsV2: builder.query({
      query: ({ losId, date }: { losId: number; date: string }) => {
        return {
          url: `v2/contractors/info/active-contractors/${losId}`,
          params: {
            date,
          },
        };
      },
    }),
    getActiveContractorsListForPreference: builder.query({
      query: () => {
        return {
          url: `/v2/contractors/contractor/active-contractors`,
        };
      },
    }),
    getContractorsLos: builder.query({
      async queryFn(arg, { getState }, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: `/v2/contractors/los/category-type/all`,
        });
        return result.data
          ? {
              data: getOrderedLosOptions(
                result.data as any
              ) as Array<selectItemType>,
            }
          : { error: result.error as any };
      },
    }),
    getContractorsLosAllType: builder.query({
      query: () => {
        return {
          url: `/v2/contractors/los/type/all`,
        };
      },
    }),
    getPreferencesAssignmentType: builder.query({
      query: () => ({
        url: `/v2/member/contractor-preferences/assignment-type`,
        method: 'GET',
      }),
    }),
    getPreferenceUsers: builder.query({
      query: () => ({
        url: `/v1/member/info/preference/users`,
        method: 'GET',
      }),
    }),
    getDashboardContractors: builder.query({
      query: () => ({
        url: `/v2/search/contractor/contractors/non-system`,
        method: 'GET',
      }),
    }),
    getNotificationMethods: builder.query({
      query: () => ({
        url: `/v1/contractors/info/notification-methods`,
        method: 'GET',
      }),
    }),
    getIdentificationTypes: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/personnel/identification-types/select`,
        method: 'GET',
      }),
    }),
    getCertificationTypes: builder.query<Array<selectItemType>, {}>({
      query: () => ({
        url: `/v1/personnel/certifications-types/select`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useLazyGetTableUsersIdQuery,
  useLazyGetBusinessTypesQuery,
  useGetBusinessTypesQuery,
  useLazyGetAgreementsStatusQuery,
  useLazyGetCategoryTypesQuery,
  useLazyGetRideServiceCategoryTypesQuery,
  useLazyGetServicesTypesQuery,
  useLazyGetEquipmentAndAddonQuery,
  useLazyGetRideEquipmentIcd10Query,
  useLazyGetRideEquipmentCatalogQuery,
  useLazyGetMarkUpTypeQuery,
  useLazyGetModeOfTransportSelectDataQuery,
  useLazyGetModeOfTransportAllTypesQuery,
  useLazyGetBillQualifierTypeQuery,
  useLazyGetGenderSelectDataQuery,
  useLazyGetSpokenLanguagesQuery,
  useLazyGetMethodVerificationsQuery,
  useLazyGetVehicleModelSelectDataByMakeIdQuery,
  useLazyGetVehicleMakeSelectDataQuery,
  useLazyGetVehicleColorSelectDataQuery,
  useLazyGetVehicleTypeSelectDataQuery,
  useLazyGetVehicleStatusSelectDataQuery,
  useLazyGetVehicleRegistrationIssuingAuthoritySelectDataQuery,
  useLazyGetVehicleInspectionTypeSelectDataQuery,
  useLazyGetVehicleInspectionOrganizationSelectDataQuery,
  useLazyGetVehicleInspectionDeterminationSelectDataQuery,
  useLazyGetVehiclePermitIssuingAuthoritySelectDataQuery,
  useLazyGetPersonnelIdentificationTypeSelectDataQuery,
  useLazyGetPersonnelIdentificationIssuingSelectDataQuery,
  useLazyGetPersonnelCertificationsTypeSelectDataQuery,
  useLazyGetPersonnelCertificationsIssuingSelectDataQuery,
  useLazyGetPersonnelScreeningsTypeSelectDataQuery,
  useLazyGetPersonnelScreeningsIssuingSelectDataQuery,
  useLazyGetPersonnelPermitTypeSelectDataQuery,
  useLazyGetPersonnelPermitIssuingSelectDataQuery,
  useLazyGetContractorsTypeSelectDataQuery,
  useLazyGetContractorsAtmsSelectDataQuery,
  useLazyGetContractorsStatusSelectDataQuery,
  useLazyGetRelationshipSelectDataQuery,
  useLazyGetInsuranceTypeSelectDataQuery,
  useLazyGetInsuranceInsurerSelectDataQuery,
  useLazyGetInsuranceBrokerSelectDataQuery,
  useLazyGetContractTypeSelectDataQuery,
  useLazyGetLicenseTypeSelectDataQuery,
  useLazyGetPermitInsuranceTypeSelectDataQuery,
  useLazyGetUserTypeSelectDataQuery,
  useLazyGetSurveyTemplateSelectDataQuery,
  useLazyGetPersonnelItemTypeSelectDataQuery,
  useLazyGetPersonnelItemStatusSelectDataQuery,
  useLazyGetPreferenceAllTagsQuery,
  useLazyGetPreferenceSelectedTagsQuery,
  useLazyGetPlacesLocationTypesQuery,
  useLazyGetLimitsTypesQuery,
  useLazyGetMemberInfoPriorityQuery,
  useLazyGetVerificationMethodsQuery,
  useLazyGetSendingMethodsQuery,
  useLazyGetWarningMethodsQuery,
  useGetServicesMutation,
  useLazyGetContractorsQuery,
  useLazyGetTimesQuery,
  useLazyGetPlaceLocationsSelectQuery,
  useLazyGetPayorSelectQuery,
  useLazyGetHealthPlanSelectQuery,
  useLazyGetUserTypeFiltrationSelectQuery,
  useLazyGetUserPermissionsFiltrationSelectQuery,
  useLazyGetChangedByFiltrationSelectQuery,
  useLazyGetViewedByFiltrationSelectQuery,
  useLazyGetNotedByFiltrationSelectQuery,
  useGetLosContractorsMutation,
  useLazyGetRideSegmentStatusSelectQuery,
  useLazyGetRideSegmentStatusChangeSelectQuery,
  useLazyGetReasonsByStatusSelectQuery,
  useGetActiveContractorsQuery,
  useLazyGetActiveContractorsQuery,
  useLazyGetPayerActiveContractorsQuery,
  useLazyGetActiveContractorsV2Query,
  useRideSegmentReactivateMutation,
  useLazyGetRideSegmentReactivateStatusQuery,
  useGetRideSegmentReactivateStatusQuery,
  useLazyGetBusinessTypesByIdQuery,
  useLazyGetContractorsLosQuery,
  useLazyGetContractorsLosAllTypeQuery,
  useLazyGetActiveContractorsListForPreferenceQuery,
  useLazyGetPreferencesAssignmentTypeQuery,
  useLazyGetPreferenceUsersQuery,
  useGetDashboardContractorsQuery,
  useLazyGetNotificationMethodsQuery,
  useLazyGetVehicleByIdQuery,
  useLazyGetVehicleLosByIdQuery,
  useLazyGetIdentificationTypesQuery,
  useLazyGetCertificationTypesQuery,
  useLazyGetVehicleModelSelectDataQuery,
} = selectsApi;
